import useApi, { ApiOptions } from '../base/useApi';
interface Params {
  id: string;
  note: string;
  open: number;
  onHand: number;
  isLoan: boolean;
}

interface Result {}

const options: ApiOptions = {
  method: 'post',
  urlPath: '/migration/save_item_details/',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useSaveMigrationItemDetailsLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useSaveMigrationItemDetailsLazy;
